import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateModelForm from "@/components/CreateModelForm";

export const Route = createFileRoute("/dashboard/settings/models/new")({
  component: CreateModelPage,
});

function CreateModelPage() {
  return <CreateModelPageComponent />;
}

// Exported for testing
export function CreateModelPageComponent() {
  return (
    <EntityFormPage
      title="Create Model"
      description="Add a new model to the catalog."
      backHref="/dashboard/settings/models"
    >
      <CreateModelForm />
    </EntityFormPage>
  );
}
